import { WhatsAppSettings } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/settings/whatsapp')({
	component: RouteComponent,
})

function RouteComponent() {
	return <WhatsAppSettings />
}
